import React from 'react';

const GB42Theme = {
  headerLogo: {
    src: '/themes/theme/gb42/logo.png',
    alt: 'BLUE 42 Logo',
    size: 70,
  },
  darkLogo: {
    src: '/themes/theme/gb42/logo.png',
    alt: 'BLUE 42 Logo',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 80,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'BLUE 42 Agency',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="300" src="/themes/theme/gb42/logo-vertical.png" alt="BLUE 42 Logo" />
      <br /><br />
      <h3>BLUE 42 Influencers</h3>
    </div>
  ),
  shareSite: 'https://reports.goblue42.com',
};

export default GB42Theme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/goblue42.js
 **/